const BASE_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:8000'

async function handleResponse<T>(res: Response): Promise<T> {
  if (res.ok) return res.json() as Promise<T>

  let detail: string | undefined
  try {
    const body = await res.json()
    detail = body?.detail
  } catch {
    // ignore parse errors
  }

  if (res.status === 401) throw new Error('unauthorized')
  if (res.status === 403) throw new Error(detail ?? 'Plan upgrade required')
  throw new Error(detail ?? `Request failed with status ${res.status}`)
}

function authHeaders(jwt: string): Record<string, string> {
  return { Authorization: `Bearer ${jwt}` }
}

function jsonHeaders(jwt: string): Record<string, string> {
  return { 'Content-Type': 'application/json', ...authHeaders(jwt) }
}

export interface JudgeMeStatus {
  connected: boolean
  shop_domain: string | null
  last_synced_at: string | null
}

export async function connectJudgeMe(
  jwt: string,
  locationId: string,
  apiToken: string,
  shopDomain: string,
): Promise<void> {
  const res = await fetch(
    `${BASE_URL}/api/locations/${encodeURIComponent(locationId)}/judgeme/connect`,
    {
      method: 'POST',
      headers: jsonHeaders(jwt),
      body: JSON.stringify({ api_token: apiToken, shop_domain: shopDomain }),
    },
  )
  await handleResponse<unknown>(res)
}

export async function disconnectJudgeMe(jwt: string, locationId: string): Promise<void> {
  const res = await fetch(
    `${BASE_URL}/api/locations/${encodeURIComponent(locationId)}/judgeme/disconnect`,
    {
      method: 'DELETE',
      headers: authHeaders(jwt),
    },
  )
  await handleResponse<unknown>(res)
}

export async function getJudgeMeStatus(
  jwt: string,
  locationId: string,
): Promise<JudgeMeStatus> {
  const res = await fetch(
    `${BASE_URL}/api/locations/${encodeURIComponent(locationId)}/judgeme/status`,
    { headers: authHeaders(jwt) },
  )
  return handleResponse<JudgeMeStatus>(res)
}
